import {
  CardContent,
  Typography,
  Box,
  Divider,
  IconButton,
  Button as MUIbutton
} from "@mui/material";
import { StyledCard, StyledChip } from "./styled";
import Button from "../../../../../common/components/button/Button";
import styled from "@emotion/styled";

const MUICustomButton = styled(MUIbutton)(({ theme }) => ({
  background: process.env.REACT_APP_ENV != 'PRODUCTION' ? 'rgb(213, 63, 63)' : '',
  color: '#fff',
  '&:hover': {
    background: process.env.REACT_APP_ENV != 'PRODUCTION' ? 'rgb(213, 63, 63)' : '',
    boxShadow: 'none',
    opacity: 1,
  },
}));

export default function ProvisioningCard({
  cardData,
  openProvisioningForm,
  serviceState,
  viewProvisioningStatus,
  statusData,
  newCustomer
}) {

  return (
    <StyledCard
      variant="outlined"
      sx={{ p: 2, maxWidth: 450 }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">

          <IconButton aria-label="close" sx={{ boxShadow: 2, borderRadius: 2 }} >
            {cardData.icon}
          </IconButton>
          {cardData?.isRecommended && (
            <StyledChip
              label="Recommended"
              size="small"
              variant="outlined"
            />
          )}

        </Box>

        {/* Title and description */}
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="h6" fontWeight="bold">
            {cardData.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {cardData.subTitle}
          </Typography>
        </Box>
        <Divider />

        {/* Action button */}
        <Box display="flex" justifyContent="flex-end">
          {serviceState.configuration?.isAppConsented && statusData.length > 0 && cardData.buttonValue == 'AP' ? (
            <Button
              variant="contained"
              text="View Status"
              onClick={() => viewProvisioningStatus(cardData.buttonValue)}
            />
          ) : (
            <>
              <MUICustomButton
                variant="contained"
                disabled={(cardData.buttonValue == 'SAP' && statusData.length == 0 && !newCustomer) ||
                  (cardData.buttonValue == 'AP' && statusData.length == 0 && !newCustomer) ||
                  (cardData.buttonValue == 'MP' && statusData.length == 0 && !newCustomer)
                }
                onClick={() => openProvisioningForm(cardData.buttonValue)}
              >
                {/* {(serviceState.configuration?.isAppConsented && statusData.length > 0 && cardData.buttonValue == 'SAP') ? 'View Status' : 'Start'} */}
                {(!newCustomer && statusData.length > 0 && cardData.buttonValue == 'SAP') ? 'View Status' : 'Start'}
              </MUICustomButton>
            </>
          )}
        </Box>

      </CardContent>
    </StyledCard>
  );
}
